import React from 'react';
import {
  string, bool, number, shape,
} from 'prop-types';

import { colors } from '@/colors';
import { stySeparator } from './styles';

/**
 * Separator Component
 * Add an separation element between content
 * @param {{
 * height: number;
 * top: number;
 * bottom: number;
 * color: string;
 * isShadow: boolean;
 * style: object;
 * }} props
 * @example
 * <Separator color={N50} />
 */

const Separator = (props) => {
  const {
    color, top, bottom, isShadow, height, style, ...rest
  } = props;

  const styProps = {
    height, top, bottom, color, isShadow,
  };

  return <div className={stySeparator(styProps)} style={style} {...rest} />;
};

// TODO: change to use styled system
Separator.propTypes = {
  height: number,
  top: number,
  bottom: number,
  color: string,
  isShadow: bool,
  style: shape({}),
};

Separator.defaultProps = {
  height: 1,
  top: 0,
  bottom: 0,
  color: colors.NEUTRAL_3,
  isShadow: false,
  style: {},
};

export default Separator;
